<template>
  <header
    :class="{ 'bd-banner-navbar': isBannerEnabled, 'bd-navbar-border-repairify': isRepairify, 'bd-navbar-border-mahle': isMahle, 'bd-navbar-border-default': !isRepairify && !isMahle, 'bd-navbar-border-clever': isClever}"
    class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar"
  >
    <div class="row custom-row">
      <div class="col-sm">
        <a
          @click="toggleNav"
          :class="{'custom-menu':!isClever,'custom-menu-clever':isClever }"
        ><i class="fa fa-bars"></i></a>
        <!-- asTech Logo -->
        <a
          class="navbar-brand mr-0 mr-md-2 custom-logo-link"
          @click="goHome"
          aria-label="diagnostics"
        >
          <img
            :src="logo"
            alt="diagnostics"
            style="height: 48px"
          />
        </a>
        <!-- Horizontal Menu Links -->
        <div class="navbar-nav-scroll">
          <ul class="navbar-nav bd-navbar-nav flex-row">
            <li
              class="nav-item"
              v-for="n of nav"
              :key="n.name"
            >
              <router-link
                exact
                class="nav-link"
                v-if="isAllowed(n.url)"
                :to="n.url"
                title="n.name"
              >{{n.name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm">
        <h2 class="custom-title">{{ $t(appName) }}</h2>
          <!--
            Credit field: Remaining credit in MAHLE COIN, as per the specific WS info. In red if credit = 0, in green if> 0.
            Diagnostic license field: Diagnostic license status, as per the specific WS info, In red when “Expired”
            (when the WS return the error code 500) in green when “Active”.
          -->
          <div class="custom-list" v-if="isMahle">
            <ul>
              <li>
                {{ $t('mahle.label.credit') + ':' }} <span :class="creditClass">{{ mahleCoinBalance }}</span>
              </li>
              <li>
                {{ $t('mahle.label.diagnosticlicense') + ':' }} <span :class="licenseClass">{{ mahleDiagnosticLicenseStatus }}</span>
              </li>
            </ul>
          </div>
      </div>
      <div class="col-sm">
        <div class="custom-user">
          <!-- Username / Logout -->
          <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
            <li
              v-if="userName"
              class="nav-item"
            >
              <a
                id="userProfile"
                href="#"
                @click="goUserProfile"
                :class="{'nav-link': isClever === false, 'nav-link-clever':isClever, 'custom-link':true}"
                title="userProfile"
              >
                <i class="fas fa-user pr-1"></i>
                {{ userName }}
              </a>
            </li>
            <li class="nav-item">
              <a
                id="logout"
                href="#"
                @click="logout"
                :class="{'nav-link': isClever === false, 'nav-link-clever':isClever, 'custom-link':true}"
                title="logout"
              >
                <i class="fas fa-sign-out-alt"></i>
                {{ $t('logout.label.title') }}
              </a>
            </li>
          </ul>
          <div class="custom-name">
            <span>{{ lastName }} </span>
          </div>
        </div>
      </div>
    </div>
    <audio
      id="chatNotifier"
      src="https://dxstmhyqfqr1o.cloudfront.net/sound/SendBird-default.mp3"
      class="custom-audio"
    />
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/plugins/globals.js'
export default {
  name: 'nav-top',
  data() {
    return {
      nav: [],
      toggleBar: false
    }
  },
  computed: {
    ...mapGetters('auth', ['userProfile', 'isAllowed', 'mahleCoinBalance', 'mahleDiagnosticLicenseStatus']),
    isUKOnly: {
      get() {
        // UK only clients.
        let _appId = globals.appId()
        if (parseInt(_appId) === 1) {
          return true
        }
        return false
      }
    },
    isRepairify() {
      if (this.isUKOnly && globals.isRepairify()) {
        return true
      }
      return false
    },
    isMahle() {
      return globals.isMahle()
    },
    isClever: {
      get() {
        return globals.isClever()
      }
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    fullname() {
      let name = ''
      if (this.userProfile !== undefined && this.userProfile !== null) {
        name = `${this.userProfile.firstName} ${this.userProfile.lastName}`.trim()
      }
      return name
    },
    userName: {
      get() {
        let name = ''
        if (this.userProfile !== undefined && this.userProfile !== null) {
          name = `${this.userProfile.userName}`.trim()
        }
        return name
      }
    },
    lastName: {
      get() {
        let name = ''
        if (this.userProfile !== undefined && this.userProfile !== null) {
          name = `${this.userProfile.lastName}`.trim()
        }
        return name
      }
    },
    appId() {
      return globals.appId()
    },
    appName() {
      return globals.appName()
    },
    logoPath() {
      return globals.logoPath()
    },
    logo() {
      let _logo = ''
      if (this.appId === 5) {
        _logo = '/static/protech.svg'
      } else {
        _logo = this.logoPath
      }
      console.log('Logo path:', _logo)
      return _logo
    },
    creditClass: {
      get() {
        if (this.mahleCoinBalance <= 0 || this.mahleCoinBalance === '?') {
          return 'red-text'
        }
        return 'green-text'
      }
    },
    licenseClass: {
      get() {
        const licenseExpired = (this.mahleDiagnosticLicenseStatus === 'Expired' || this.mahleDiagnosticLicenseStatus === '?')
        if (licenseExpired) {
          return 'red-text'
        }
        return 'green-text'
      }
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    logout() {
      this.clearToken()
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
      window.location.assign('/')
    },
    toggleNav() {
      this.toggleBar = !this.toggleBar
      this.$emit('toggleBar', this.toggleBar)
    },
    closeMenu() {
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
    },
    goHome() {
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
      window.location.assign('/')
    },
    goUserProfile() {
      this.toggleBar = false
      this.$emit('toggleBar', this.toggleBar)
      if (!this.isMahle) {
        window.location.assign('/user/')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-logo-link {
  cursor: pointer;
}
.custom-audio {
  display: none;
}
.custom-row {
  width: 100%;
}
.custom-menu {
  margin-right: 15px;
  font-size: 1.5em;
  font-weight: 600;
  cursor: pointer;
  :hover {
    color: blue;
  }
}
  .custom-menu-clever {
    margin-right: 15px;
    font-size: 1.5em;
    font-weight: 600;
    cursor: pointer;

    :hover {
      color: #EAAA00;
    }
  }
.custom-title {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.custom-link {
  cursor: pointer;
}
.custom-user {
  float: right;
}
.custom-name {
  text-align: center;
  font-size: 0.8em;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.custom-list {
  ul {
    display: flex;
    padding: 0;
    margin: 0 -10px;
    list-style: none;
  }
  li {
    margin: 0 10px;
  }
  display:flex;
  justify-content: center;
  width: 100%;
}
.red-text {
  color:#FF0000
}
.green-text {
  color:#66CC66
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-top.vue